import React, { useState, useEffect } from "react"
import { Link } from "gatsby"
import axios from "axios"
import Nav from "../nav"
import SEO from "../../components/seo"
import Logo from "../../images/favicon.png"

const JobDescription = (props) => {
   let axiosConfig = {
    headers: {
      "Access-Control-Allow-Origin": "*",
      api_key: process.env.SPARKLE_CAREERS,
       "content-type": "application/json",
    },
  }

  const [job, setJob] = useState([])
  const [loading, setLoading] = useState(true)
  const getJobs = () => {
    axios({
      method: "get",
      url: `${process.env.GATSBY_SPARKLE_LOCAL_BASE_URL}/api/v1/career/${props.id}`,axiosConfig
     
    })
      .then((response) => {
        setJob(response.data)
        setLoading(false)
      })
      .catch((error) => {
        // console.log(error)
      })
  }

  useEffect(() => {
    getJobs()
  }, [])

  return (
    <>
      <SEO
        title={Object.values(job).length > 0 && job.name + " - Sparkle Microfinance Bank"}
        desc="We are a creative tribe of diverse talents building an exciting financial ecosystem that lives on your smartphone"
      />
      <div className="job-description pb-lg-5">
        <div className="nav-wrapper bg__sparkle--black">
          <div className="container">
            <Nav />
          </div>
        </div>
        <div className="container py-lg-5">
          <div className="row justify-content-center">
            {loading ? (
              <div className="text-center my-5 py-5">
                <div className="loader simple-circle mx-auto">
                  <img src={Logo} className="img-fluid" alt="sparkle logo" />
                </div>
              </div>
            ) : (
              <div className="col-lg-5 text-center">
                <h1 className="my-3 text-white sparkle--mont__900">
                  {Object.values(job).length > 0 && job.name}
                </h1>
                <p className="text-white mb-4">
                  {" "}
                  {
                    job.department_name}
                </p>
                <Link
                  to={`/sparkle-jobs/${props.id}/apply`}
                  className="btn sparkle--button__green px-lg-5 my-3"
                >
                  Apply Now
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8 py-3">
            {loading ? (
              <div className="text-center my-5 py-5">
                {/* <div className="loader simple-circle mx-auto">
                  <img src={Logo} className="img-fluid" alt="sparkle logo" />
                </div> */}
              </div>
            ) : (
              <div className="px-lg-4 px-2 py-lg-5 sparkle--color__light mt-lg-3">
                <div
                  dangerouslySetInnerHTML={{
                    __html: `${job.web_description}`,
                  }}
                ></div>
                <Link
                  to={`/sparkle-jobs/${props.id}/apply`}
                  className="btn sparkle--button__green px-lg-5 my-2"
                >
                  Apply Now
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default JobDescription
